export default [
  { value: '>', label: 'above' },
  { value: '>=', label: 'above or equal to' },
  { value: '<', label: 'below' },
  { value: '<=', label: 'below or equal to' },
] as const;
